export default __webpack_public_path__ + "static/media/330_dummy2016-yoga02-mobile-de.a9077586.png";